/**
 * Cart Animations
 * Handles smooth animations for cart interactions
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ==========================================
  // CART ITEM REMOVAL ANIMATION
  // ==========================================
  
  // Listen for cart remove button clicks
  document.addEventListener('click', function(e) {
    const removeButton = e.target.closest('.cart-item__remove-button');
    if (removeButton) {
      const cartItem = removeButton.closest('.cart-item-new');
      if (cartItem) {
        // Add removing class for animation
        cartItem.classList.add('removing');
        
        // Remove from DOM after animation completes
        setTimeout(() => {
          cartItem.remove();
          
          // Check if cart is empty after removal
          const remainingItems = document.querySelectorAll('.cart-item-new:not(.removing)');
          if (remainingItems.length === 0) {
            // Trigger cart empty state if needed
            document.dispatchEvent(new CustomEvent('cart:empty'));
          }
        }, 400); // Match CSS transition duration
      }
    }
  });
  
  // ==========================================
  // PROGRESS BAR ANIMATION
  // ==========================================
  
  function animateProgressBar(newProgress, isGoalReached = false) {
    const progressFill = document.querySelector('.progress-bar__fill');
    const progressLabel = document.querySelector('.progress-bar__label');
    const progressRemaining = document.querySelector('.progress-bar__remaining');
    
    if (!progressFill) return;
    
    // Animate the fill width
    progressFill.style.width = `${newProgress}%`;
    
    // Add celebration effect if goal reached
    if (isGoalReached) {
      progressFill.classList.add('goal-reached');
      setTimeout(() => {
        progressFill.classList.remove('goal-reached');
      }, 600);
    }
    
    // Animate text changes
    if (progressLabel) {
      progressLabel.classList.add('updated');
      setTimeout(() => {
        progressLabel.classList.remove('updated');
      }, 300);
    }
    
    if (progressRemaining) {
      progressRemaining.classList.add('updated');
      setTimeout(() => {
        progressRemaining.classList.remove('updated');
      }, 300);
    }
  }
  
  // ==========================================
  // CART UPDATE ANIMATIONS
  // ==========================================
  
  function updateCartAnimations() {
    // Get current cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Calculate progress bar
        const targetAmount = 6000; // Free shipping threshold (6000 cents in the store currency)
        const currentAmount = cart.total_price;
        const progressPercentage = Math.min((currentAmount / targetAmount) * 100, 100);
        const isGoalReached = currentAmount >= targetAmount;
        
        // Animate progress bar
        animateProgressBar(progressPercentage, isGoalReached);
        
        // Update cart summary if needed
        updateCartSummary(cart);
      })
      .catch(error => {
        console.error('Error updating cart animations:', error);
      });
  }
  
  function updateCartSummary(cart) {
    // Update cart summary values with animation
    const subtotalElement = document.querySelector('.cart-summary__value');
    const totalElement = document.querySelector('.cart-summary__line--total .cart-summary__value');
    
    if (subtotalElement) {
      const newSubtotal = formatMoney(cart.total_price, cart.currency);
      if (subtotalElement.textContent !== newSubtotal) {
        // Add a subtle animation to the updated value
        subtotalElement.style.transform = 'scale(1.1)';
        subtotalElement.textContent = newSubtotal;
        setTimeout(() => {
          subtotalElement.style.transform = 'scale(1)';
        }, 200);
      }
    }
    
    if (totalElement) {
      const newTotal = formatMoney(cart.total_price, cart.currency);
      if (totalElement.textContent !== newTotal) {
        totalElement.style.transform = 'scale(1.1)';
        totalElement.textContent = newTotal;
        setTimeout(() => {
          totalElement.style.transform = 'scale(1)';
        }, 200);
      }
    }
  }
  
  function formatMoney(cents, currencyCode) {
    // Use the store's actual currency (returned by /cart.js) instead of a hard-coded one.
    const currency = currencyCode || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    const locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || undefined;
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }
  
  // ==========================================
  // QUANTITY CHANGE ANIMATIONS
  // ==========================================
  
  // Listen for quantity changes
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('cart-item__quantity-select')) {
      const cartItem = e.target.closest('.cart-item-new');
      if (cartItem) {
        // Add updating class
        cartItem.classList.add('updating');
        
        // Remove updating class after a delay
        setTimeout(() => {
          cartItem.classList.remove('updating');
        }, 1000);
      }
    }
  });
  
  // ==========================================
  // EVENT LISTENERS
  // ==========================================
  
  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartAnimations);
  document.addEventListener('cart:refresh', updateCartAnimations);
  document.addEventListener('cart-drawer:updated', updateCartAnimations);
  
  // Initialize animations on load
  updateCartAnimations();
  
  // ==========================================
  // SUCCESS ANIMATIONS
  // ==========================================
  
  // Add success animation when items are added
  document.addEventListener('cart:item-added', function(e) {
    // Find the newly added item and add a success animation
    const cartItems = document.querySelectorAll('.cart-item-new');
    const lastItem = cartItems[cartItems.length - 1];
    
    if (lastItem) {
      lastItem.style.animation = 'itemAdded 0.6s ease-out';
      setTimeout(() => {
        lastItem.style.animation = '';
      }, 600);
    }
  });
  
  // Add CSS for success animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes itemAdded {
      0% { 
        transform: scale(0.8); 
        opacity: 0; 
      }
      50% { 
        transform: scale(1.05); 
        opacity: 0.8; 
      }
      100% { 
        transform: scale(1); 
        opacity: 1; 
      }
    }
    
    .cart-summary__value {
      transition: transform 0.2s ease;
    }
  `;
  document.head.appendChild(style);
  
});
